import React from "react";
import { Container, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import downTimeImg from "../../assets/images/maintenance_page_2x.png";

export const DownTimeScreen = () => {
    return (
        <>
            <div
                style={{
                    backgroundImage: `url(${downTimeImg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPositionX: "center",
                    backgroundColor: "#fff"
                }}
            >
                <Box
                    sx={{
                        position: "absolute"
                    }}
                />
                <Container
                    style={{
                        alignItems: "center",
                        height: "100vh",
                        display: "flex",
                        justifyContent: "center"
                    }}
                >
                    <Box sx={{ flexGrow: 1, padding: "20px" }}>
                        <Grid
                            container
                            spacing={3}
                            sx={{
                                marginTop: "28rem",
                                textAlign: "center",
                                color: "#0c77bc",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#fff"
                            }}
                        >
                            <h1>
                                We're fastening some screws to serve you better.{" "}
                                <br />
                                Please come back later.
                            </h1>
                        </Grid>
                    </Box>
                </Container>
            </div>
        </>
    );
};
